<template>
<v-dialog
    v-model="dialog"
    max-width="920"
>
    <v-card>
        <v-card-title>Order Attribution Settings</v-card-title>

        <v-card-text>
            <v-select
                v-model="order_attribution_settings_id"
                :items="settings_choices"
            />

            <div>

                <b>Criteria for Order Attribution ({{settings_label}})</b>
                <ul>
                <li>The bulk message was sent to the customer within the {{order_prox_days}} days before the order was placed</li>
                <li>If the customer was sent multiple bulk messages within the {{order_prox_days}} before the order was placed, only the most recent bulk message sent to the customer before the order receives any order attribution</li>
                
                <li
                    v-if="exclude_order_types.length == 0"
                >
                    The order may be of any type
                </li>
                <li
                    v-else
                >
                    The order type <u>was not</u>
                </li>
                <ul
                    v-if="exclude_order_types.length != 0"
                >
                    <li
                    v-for="(item, key) in exclude_order_types"
                    :key="'ex_order_type_'+key"
                    >
                    {{item}}
                    </li>
                </ul>
                <li>You can customze the order proximity and the types of orders used to caculate order attriubtion  <a style="text-decoration: underline;" v-on:click="onClickEditSettings">by changing your organization's order attribution settings</a>.</li>
                
                </ul> 

            </div>

            
        </v-card-text>

        <v-card-actions>
            <v-btn
                text
                v-on:click="onClickTechnicalDetails"
            >
                Technical Details
            </v-btn>

            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onSave"
                :disabled="order_attribution_settings_id == original_order_attribution_settings_id && order_attribution_settings_id != null"
            >
            Save
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>
const _ = require('lodash');
export default {

    data() {
        return {
            dialog: false,
            order_attribution_settings_id: null,
            original_order_attribution_settings_id: null,
            settings_choices: [],
            results: [],

            analytics_group_id: null,
            settings_profile: null,
        }
    },

    methods: {

        showDialog(analytics_group_id, order_attribution_settings_id)
        {
            this.analytics_group_id = analytics_group_id;
            this.order_attribution_settings_id = order_attribution_settings_id;

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/integrations/crm/order/attribution/settings/get-profile',
            
                'params' : {
                        'organization_id': this.$route.params.organization_id,
                        'is_archived': false,
                    },
            
                'on_success': (data) => {
                        this.settings_profile = _.cloneDeep(data);
                        this.results = _.cloneDeep(data.results);

                        this.settings_choices = this.results.map(
                            (item) => { return { 'text': item.label, 'value': item.order_attribution_settings_id }; },
                        );

                        this.original_order_attribution_settings_id = this.order_attribution_settings_id;
                    },

            
                'on_error': 'Unable to list order attribution settings',
            });

            this.dialog = true;
        },

        onClickTechnicalDetails()
        {
            this.$rc.technicalDetails({
                'title': 'Technical Details',
                'technical_details': 
                {
                    'details': [{
                        'header': 'Details',
                        'json': {
                            'order_attribution_settings_id': this.order_attribution_settings_id,
                            'original_order_attribution_settings_id': this.original_order_attribution_settings_id,
                            'analytics_group_id': this.analytics_group_id,
                            'settings_profile': this.settings_profile,
                            'settings_choices': this.settings_choices,
                        }
                    }],
                },
            });
        },

        onSave()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/integrations/crm/order/attribution/settings/bulk-message-order-attribution-settings',
            
                'params' : {
                        'organization_id': this.$route.params.organization_id,
                        'analytics_group_id': this.analytics_group_id,
                        'order_attribution_settings_id': this.order_attribution_settings_id
                    },
            
                'on_success': (data) => {
                        this.$emit('update', true);
                        this.dialog = false;
                    },
            
                'on_error': 'Unable to change bulk message order attribution settings',
            });

        },

        onCancel()
        {
            this.dialog = false;
        },

        onClickEditSettings()
        {
            this.$router.push({
                'name': 'settings-organization-order-attribution',
                'params' : {
                    'organization_id': this.$route.params.organization_id,
                }
            });
        },
    },

    computed: {
        settings_label() {
            
            let item = this.results.find((el) => el.order_attribution_settings_id == this.order_attribution_settings_id);

            if ( item == null )
                return 'RedChirp Default';

            return item.label;
        },

        order_prox_days() {
            let item = this.results.find((el) => el.order_attribution_settings_id == this.order_attribution_settings_id);

            if ( item == null )
                return 14;

            return item.order_prox_days;
        },

        exclude_order_types() {
            let item = this.results.find((el) => el.order_attribution_settings_id == this.order_attribution_settings_id);

            if ( item == null )
                return [];

            return item.exclude_order_types;
        },

    },
}
</script>

<style lang="scss" scoped>
</style>